import { CreditCard, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Props {
  onClaim?: () => void;
}

export const AdsOffersFinancing = ({ onClaim }: Props) => (
  <section className="py-16 bg-muted/30">
    <div className="container mx-auto px-4 max-w-4xl">
      <h2 className="text-2xl md:text-3xl font-extrabold text-foreground text-center mb-10">
        Special <span className="text-primary">Offers</span>
      </h2>
      <div className="grid md:grid-cols-2 gap-6">
        {/* Financing Card */}
        <div className="rounded-xl border bg-card p-6 text-center shadow-sm">
          <CreditCard className="w-10 h-10 text-primary mx-auto mb-4" />
          <h3 className="text-xl font-extrabold text-foreground mb-2">0% Financing</h3>
          <p className="text-3xl font-extrabold text-primary mb-1">18 Months</p>
          <p className="text-sm text-muted-foreground mb-6">No interest, no payments for 18 months on qualifying roofing projects. Subject to credit approval.</p>
          <Button className="font-bold" onClick={onClaim}>Claim This Offer</Button>
        </div>
        {/* Military/Senior */}
        <div className="rounded-xl border bg-card p-6 text-center shadow-sm">
          <Shield className="w-10 h-10 text-primary mx-auto mb-4" />
          <h3 className="text-xl font-extrabold text-foreground mb-2">Senior & Military</h3>
          <p className="text-3xl font-extrabold text-primary mb-1">Extra $250 OFF</p>
          <p className="text-sm text-muted-foreground mb-6">Thank you for your service. We offer additional discounts to veterans, active military, and senior homeowners.</p>
          <Button className="font-bold" onClick={onClaim}>Learn More</Button>
        </div>
      </div>
    </div>
  </section>
);
